import { roundTo  } from 'round-to'

export function splitStringToNumber(str: string) {
    let num = str?.replace(/[^0-9]/g, '') || '';
    return parseInt(num, 10);
}

export const toFixedNumber = (number: number | string, rounded = 6) => {
    if (Math.abs(Number(number)) < 0.01) {
      return roundTo(Number(number), rounded + 2);
    } else {
      return roundTo(Number(number), rounded);
    }
  };

  export function compactAddressStr(address, COMPACT_WALLET_LENGTH = 5) {
    const compactLength =
      ((address.length < COMPACT_WALLET_LENGTH
        ? address.length
        : COMPACT_WALLET_LENGTH) -
        3) /
      2
    return address
      .substring(0, compactLength)
      .concat('...')
      .concat(address.substring(address.length - compactLength))
  }